export default "__VITE_ASSET__CygexT4Q__"